module.exports = __webpack_public_path__ + "static/media/chatapi.2ae39d34.svg";